/** Fluent elevation ramp (shadow2 → shadow64): a tight ambient shadow plus a soft key shadow. */
const boxShadows = {
  xs: "0 0 2px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.14)",
  sm: "0 0 2px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.14)",
  md: "0 0 2px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.14)",
  lg: "0 0 2px rgba(0, 0, 0, 0.12), 0 8px 16px rgba(0, 0, 0, 0.14)",
  xl: "0 0 8px rgba(0, 0, 0, 0.12), 0 14px 28px rgba(0, 0, 0, 0.14)",
  "2xl": "0 0 8px rgba(0, 0, 0, 0.12), 0 32px 64px rgba(0, 0, 0, 0.14)",
  xxl: "0 0 8px rgba(0, 0, 0, 0.12), 0 32px 64px rgba(0, 0, 0, 0.14)",
  inner: "inset 0 1px 2px 0 rgb(0 0 0 / 0.06)",
  none: "0 0 #0000",
  xxs: "0 0 2px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.14)",
  regular: "0 0 2px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.14)",
  navbarBoxShadow: "0 0 2px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.14)",
  sliderBoxShadow: {
    thumb: "0 0 2px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.14)",
  },
  tabsBoxShadow: {
    indicator: "none",
  },
  inset: "inset 0 1px 2px 0 rgb(0 0 0 / 0.06)",
  colored: {
    primary: "0 4px 16px 0px rgba(15, 108, 189, 0.14)",
    secondary: "0 4px 16px 0px rgba(97, 97, 97, 0.14)",
    info: "0 4px 16px 0px rgba(3, 105, 161, 0.14)",
    success: "0 4px 16px 0px rgba(4, 120, 87, 0.14)",
    warning: "0 4px 16px 0px rgba(180, 83, 9, 0.14)",
    error: "0 4px 16px 0px rgba(185, 28, 28, 0.14)",
    light: "0 4px 16px 0px rgba(173, 173, 173, 0.14)",
    dark: "0 4px 16px 0px rgba(36, 36, 36, 0.14)",
  },
};

export default boxShadows;
